<template lang="pug">
  .range-select-form__content(
    @click="onClickList($event)"
  )
    .range-slider-custom(
      ref="rangeSlider"
    )
      //- .range-slider__active(
      //-   :style="{ left: left + '%', right: right + '%' }"
      //- )
      //- .range-button.left-range(
      //-   :draggable="false"
      //-   @mousedown="onKeyDownRange('left')"
      //-   @touchstart="onKeyDownRange('left')"
      //-   @ondragstart="() => (false)"
      //-   :style="{ left: left + '%' }"
      //- )
      //- .range-button.right-range(
      //-   :draggable="false"
      //-   @mousedown="onKeyDownRange('right')"
      //-   @touchstart="onKeyDownRange('right')"
      //-   @ondragstart="() => (false)"
      //-   :style="{ right: right + '%' }"
      //- )
      vue-slider-component(
        v-model="sliderValue"
        :min-range="1"
        tooltip="none"
        :min="7"
        :max="17"
        @change="onChangeRange"
      )
    .range-info
      .range-info__year {{ ageFrom }} лет
      .range-info__year {{ ageTo }} лет
    .range-buttons
      .range-buttons__cancel(
        @click="cancelRange()"
      ) Сбросить
      .range-buttons__submit(
        @click="submitRange()"
      ) Применить
</template>

<script>
import VueSliderComponent from "vue-slider-component";

export default {
  name: "RangeSelectContent",
  components: {
    VueSliderComponent
  },
  props: {
    showList: {
      type: Boolean,
      default: false
    },
    listData: {
      type: Array,
      default: () => []
    },
    defaultValue: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      sliderValue: [7, 17],
      isMoveActive: false,
      rangeType: "left",
      ageFrom: 7,
      ageTo: 17
    };
  },
  methods: {
    onChangeRange(arg) {
      this.ageFrom = arg[0];
      this.ageTo = arg[1];
    },
    onClickList(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    onBodyClick() {
      if (this.isMoveActive) {
        return;
      }
      this.$emit("close");
    },
    submitRange() {
      this.$emit("onChangeAge", `${this.ageFrom} - ${this.ageTo} лет`);
      this.$emit("close");
    },
    cancelRange() {
      this.$emit("close");
      this.ageTo = 17;
      this.ageFrom = 7;
      this.$emit("onChangeAge", "Любой возраст");
    }
  },
  mounted() {
    if (this.defaultValue !== "Любой возраст") {
      const ages = this.defaultValue.split(" - ");
      this.ageFrom = parseInt(ages[0]);
      this.ageTo = parseInt(ages[1]);
      this.sliderValue = [parseInt(ages[0]), parseInt(ages[1])];
      const right = 100 - ((this.ageTo - 3) * 83) / 12;
      this.right = right < 0 ? 0 : right;
      this.left = ((this.ageFrom - 6) * 83) / 12;
    }
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.onBodyClick);
  },
  created() {
    document.body.addEventListener("click", this.onBodyClick);
  }
};
</script>
